import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButton} from 'mui-tiptap';

const StyledEditorMenuButtonHeadingUp = styled(MenuButton)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonHeadingUp.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonHeadingUp;
